import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { useParams, useHistory } from 'react-router';

import { FocusedCard } from '@brokerbay/design-components';

import { CompleteProfileView, SetPasswordView, ReviewTOSView } from './steps';
import { GetStartedView } from '../common/GetStartedView';

import { buildNavigationHandler } from '../../util';
import {
  UserOnboardingContextProvider,
  useUserOnboardingContext,
} from '../../contexts/UserOnboardingContext';
import { Steps } from '../../types';
import { ClaimPrefix, UserOnboardingStep } from '../../constants';
import { LinkToAppView } from '../common/LinkToAppView';

const WrappedOnboardingCompleteProfileView = () => {
  const { hash } = useParams<{ hash: string }>();
  return (
    <UserOnboardingContextProvider hash={hash}>
      <OnboardingCompleteProfileView hash={hash} />
    </UserOnboardingContextProvider>
  );
};

export const OnboardingCompleteProfileView = ({ hash }: { hash: string }) => {
  const history = useHistory();
  const pathPrefix = ClaimPrefix.USER_PROFILE;
  const { userProfile, setIsUnclaimedApprover } =
    useUserOnboardingContext() || {};

  const navigationHandler = (nextStep: Steps) =>
    buildNavigationHandler({
      history,
      prefix: ClaimPrefix.USER_PROFILE,
      urlParams: [{ name: 'hash', value: hash }],
      nextStep,
    });

  return (
    <FocusedCard>
      <Switch>
        <Route
          exact
          path={pathPrefix}
          render={props => (
            <GetStartedView
              type="user"
              handleGoNextStep={navigationHandler(UserOnboardingStep.PROFILE)}
              setIsUnclaimedApprover={setIsUnclaimedApprover}
              {...props}
            />
          )}
        />

        <Route
          exact
          path={`${pathPrefix}/${UserOnboardingStep.PROFILE}`}
          render={props => (
            <CompleteProfileView
              handleGoNextStep={navigationHandler(
                userProfile?.clientIdpFeatureEnabled
                  ? UserOnboardingStep.TOS
                  : UserOnboardingStep.PASSWORD,
              )}
              {...props}
            />
          )}
        />

        <Route
          exact
          path={`${pathPrefix}/${UserOnboardingStep.PASSWORD}`}
          render={props => (
            <SetPasswordView
              handleGoNextStep={navigationHandler(UserOnboardingStep.TOS)}
              handleGoBackStep={navigationHandler(UserOnboardingStep.PROFILE)}
              {...props}
            />
          )}
        />

        <Route
          exact
          path={`${pathPrefix}/${UserOnboardingStep.TOS}`}
          render={props => (
            <ReviewTOSView
              handleGoNextStep={navigationHandler(UserOnboardingStep.APP)}
              handleGoBackStep={navigationHandler(
                userProfile?.clientIdpFeatureEnabled
                  ? UserOnboardingStep.PROFILE
                  : UserOnboardingStep.PASSWORD,
              )}
              {...props}
            />
          )}
        />

        <Route
          exact
          path={`${pathPrefix}/${UserOnboardingStep.APP}`}
          render={props => <LinkToAppView />}
        />
      </Switch>
    </FocusedCard>
  );
};
export default WrappedOnboardingCompleteProfileView;
